import { ItemValueModel } from "./item-value-model";
import { ScreenAction } from "./screen-action";

export class ScreenActionModel {
  screenActionList: Array<ScreenAction>;
  planTypeList: Array<ItemValueModel>;

  constructor() {
    this.screenActionList = [];
    this.planTypeList = [];
  }
}
